<template>
    <div class="container" id="chat_box">
        <div class="left" id="chat_box_left">
            <div class="new_btn_box">
                <Button type="primary" @click="new_chat">新建会话</Button>
            </div>
            <div class="new_btn_box">
                <Button type="primary" @click="chat_list">历史会话</Button>
            </div>
            <Drawer title="历史会话" :transfer="false" :inner="true" placement="left" :closable="false" v-model="value2">
                <div style="min-height: 600px;">
                    <div v-for="(item,index) in histories" :key="index" @click="chat_history_view(item)" class="li_row" :style="{borderLeft:item.requestId==history_selected_id?'5px solid #5cadff':''}">
                        <div class="li_title"><a>{{item.title}}</a></div>
                        <div class="li_date">{{item.createdAt}}</div>
                    </div>
                </div>
                <div class="pagination">
                    <div style="display:flex;align-items:center;justify-content: flex-start;width: 100%;">
                        <Page :current="history_currentpage" :total="history_total" simple @on-change="history_paging" />
                        <div class="view_all" @click="view_rec_history_all">查看全部</div>
                    </div>
                </div>
            </Drawer>
            <div class="me_info">
                <Poptip trigger="hover" style="background-color: yellow;" width="240">
                    <!-- <Button>设置</Button> -->
                    <div slot="content" class="pop_box">
                        <!--  <Divider orientation="left">余额</Divider>
                        <div>剩余：20,000,000 tokens</div> -->
                        <Divider orientation="left">线路选择</Divider>
                        <RadioGroup v-model="vertical" vertical @on-change="set_line">
                            <Radio label="3">
                                <Icon type="social-apple"></Icon>
                                <span>线路一（推荐）</span>
                            </Radio>
                            <!-- <Radio label="2">
                                <Icon type="social-android"></Icon>
                                <span>线路二</span>
                            </Radio> -->
                            <Radio label="1">
                                <Icon type="social-windows"></Icon>
                                <span>线路二</span>
                            </Radio>
                            <!-- <Radio label="4">
                                <Icon type="social-windows"></Icon>
                                <span>线路四</span>
                            </Radio> -->
                        </RadioGroup>
                    </div>
                </Poptip>
            </div>
        </div>
        <div class="center" id="chat_box_center">
            <div id="main-content-box" ref="main-content-box" class="main-content" @scroll="handleScroll">
                <!-- <div class="row" v-for = "(item,index) in text_data">
                    <CollapsePanel
                    :expanded="item.isExpanded"
                    label="已深度思考(耗时：22秒)"
                    :is_show="item.isshow"
                    @toggle="handleToggle(item.id)" :key="item.key">
                        <p>这里是详细内容</p>
                        <p>项目进度: 80%，项目进度: 80%，项目进度: 80%，项目进度: 80%</p>
                        <p>负责人: 张三</p>
                    </CollapsePanel>
                </div> -->
                <div v-for="(item,index) in chat_messages" :key="index" class="row">
                    <div style="display: flex;flex-direction: column;width: 100%;">
                        <div v-html="item.user"></div>
                        <div v-if="item.type==1" style="width: 100%;">
                            <CollapsePanel :expanded="item.collaspe.isExpanded" :label="item.collaspe.label_txt" :is_show="item.collaspe.isShow" :is_thinking="item.collaspe.isThinking" @toggle="handleToggle(item)" :key="item.collaspe.key">
                                <div v-for="(txt,index) in item.reasoning" :key="index" v-html="txt"></div>
                            </CollapsePanel>
                        </div>
                        <div v-for="(msg,index) in item.messages" :key="index" @click="open" v-html="msg" @click.prevent="handleLinkClick">
                        </div>
                    </div>
                </div>
                <div class="dot_box" v-show="showddd">
                    <div class='dot'></div>
                    <div class='dot'></div>
                    <div class='dot'></div>
                </div>
                <div class="rec_history_box" style="display:flex;flex-direction:column;">
                    <div v-for="(item,index) in rec_history_list" :key="index" class="row" @click="chat_history_view(item)">
                        <div class="title">{{item.title}}</div>
                        <div class="operation">
                            <div class="op_time"><Time :time="item.createdAt" /></div>
                            <div class="oper">
                                <!-- <div class="icon">
                                    <Icon type="md-create" size="18" @click="rec_history_edit" />
                                </div> -->
                                <div class="icon">
                                    <Icon type="md-trash" size="20" color="#F76560" @click.prevent.stop="rec_history_del($event,item)" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="rec_finished" class="load_complete">数据已加载完成</div>
                </div>
                <div id="go_bottomopopo" class="row_bottom"></div>
                <!-- <p>主要内容区域，超出自动滚动。主要内容区域，超出自动滚动。主要内容区域，超出自动滚动。主要内容区域，超出自动滚动。</p>
                    <div style="display: flex;">
                        <div class="titl1">结果怎么样？</div>
                    </div>
                    <div class="suggest_box">
                        <div class="suggest_item">企业如何正确申报环保税？➡︎</div>
                        <div class="suggest_item">如何计算房产交易中的契税？➡︎</div>
                        <div class="suggest_item">增值税发票丢失如何处理？➡︎</div>
                    </div>
                </p> -->
            </div>
            <div class="input-area">
                <div class="tag1">
                    <!-- <Button v-for="(rcm,index) in recommends" :key="index" type="info">{{rcm.title}}</Button> -->
                </div>
                <div class="input_outer_box">
                    <div class="input_group">
                        <Input v-model="input_txt" :disabled="showddd?true:false" ref="inputTxt" :autosize="{minRows: 1,maxRows: 5}" :border="false" type="textarea" :placeholder="showddd?'AI 应答中...':'Enter 发送,Shift + Enter 换行...'" @on-keydown="handleKeyDown" @on-change="txtchange"></Input>
                    </div>
                    <div class="new_div">
                        <div :class="is_deepseek?'new_kid_select':'new_kid'">
                            <Badge :status="is_deepseek ? 'processing' : 'default'" /><a href="#" @click="toggle_dk" :style="is_deepseek ? 'color:#2d8cf0;font-weight:bold;':'color:gray;'">深度思考</a>
                        </div>
                        <div style="float:right;"><Button type="primary" class="button_send" :icon="showddd?'md-square':''" @click="submit1" :disabled="!sendable">{{showddd?'停止':'发送'}}</Button>
                        </div>
                    </div>
                </div>
                <!-- 文本输入框区域 -->
                <!-- <input class="input_box" type="text" placeholder="文本输入框"> -->
                <div class="txt_notice">内容由 AI 大模型生成，不能完全保障真实性和准确性，请仔细甄别。</div>
            </div>
        </div>
        <div class="right" id="chat_box_right"></div>
    </div>
</template>
<script>
import moment from 'moment'
import caseHeader from '../../assets/json/caseTableData.json'
import nextSearchBar from '../common/common_engine/nextSearchBar3.vue'
import eventBus from "../common/event_bus.js"
import More from "../../api/common/more.js"
import MessageQueue from "../../api/common/messagequeue2.js"
import store from '../../store/'
import marked from 'marked'
import { uuid } from 'vue-uuid'
import ConstJson from "../../api/common/constjson.js"
import { getAISign } from '../../api/lib/sign.js'
import Typewriter from 'typewriter-effect/dist/core'
import CollapsePanel from '../common/CollaspsePannel.vue'
// import DOMPurify from 'dompurify'

// const DOMPurify_config = {
//     FORBID_ATTR: ['href'] // 禁止 href 属性
// };


let constJ = new ConstJson()
let MoreFun = new More()
const ChatMessageQueue = new MessageQueue()
let cur_typewriter = null
export default {
    inject: ['getSliders', 'CreatePage', "setTaxChatIndex"],
    data() {
        return {
            // rid: +new Date(),
            spinShow3: true,
            loadSucess: true,
            input_txt: '',
            messages: [],
            chat_messages: [], //[{msgid:'000',type:0,htmlstr:''}]msgid='000'客户端,111服务端,type=0普通ai,type=1 deepseek深度思考
            current_chat_id: '',
            value2: false,
            selected: false,
            vertical: "3",
            sendable: false,
            ws: null,
            key: '',
            typeIntervalId: 0,
            typewait: false,
            sliders: this.getSliders(),
            // userGuid: store.state.user.userGuid,
            // tkn: store.state.user.token,
            recommends: [],
            showddd: false,
            histories: [],
            chat_session_id: '',
            history_selected_id: '',
            history_pagesize: 10,
            history_currentpage: 1,
            history_total: 0,

            show_rec_history: false,
            rec_history_list: [],
            rec_page: 1,
            rec_pagesize: 20,
            rec_total: 0,
            rec_finished: false,
            // time1: (new Date()).getTime() - 60 * 3 * 1000,

            is_timer_processing: false,
            is_deepseek: false,
            isExpanded: false,
            first_message_time: '',
            text_data: [
                { id: '000000001', key: '00000012', isExpanded: true, isShow: true },
            ]


        }
    },
    components: {
        'NextBar': nextSearchBar,
        CollapsePanel,
    },
    created() {
        console.log('ai chat create==>')
        ////控制客服图标隐藏

        this.$nextTick(() => {
            this.adjustDivHeight()

        })
        this.setTaxChatIndex()
        // if (document.getElementById('ECHAT_mini_icon')) {
        //     document.getElementById('ECHAT_mini_icon').style.display = "none"
        // }
        //this.new_chat()

    },
    mounted() {
        window.addEventListener('resize', () => {
            this.adjustDivHeight()
        });
    },
    beforeDestroy() {
        clearInterval(this.typeIntervalId)
        // if (document.getElementById('ECHAT_mini_icon')) {
        //     document.getElementById('ECHAT_mini_icon').style.display = "block"
        // }

    },
    methods: {
        handleLinkClick(event) {
            const target = event.target;
            // 仅处理a标签点击
            if (target.tagName === 'A') {
                event.preventDefault();
                const href = target.href;
                this.processLink(href)
            }
        },
        processLink(href) {
            /* 自定义处理逻辑 */
            console.log('拦截到链接:', href);
            this.checkLinkOut(href)
           
            // 示例3: 埋点统计
            //this.$track('link_click', { url: href });
        },
        checkLinkOut(href) {
            this.$Modal.confirm({
                title: '提示',
                content: `<p>系统检测到您将要访问外部链接：${href}，外部链接存在安全隐患，是否为您跳转？</p>`,
                cancelText: "否",
                okText: '是',
                onOk: () => {
                    window.open(href, '_blank', 'noopener,noreferrer');
                },
                onCancel: () => {
                    return
                }
            });
        },
        handleToggle(item) {
            console.log(item)
            // const componentInstance = this.$refs[value.collaspe.id]
            item.collaspe.isExpanded = !item.collaspe.isExpanded
            console.log(item.collaspe.isExpanded)

        },
        toggle_dk() {
            this.is_deepseek = !this.is_deepseek
        },
        tt2(typewriter, txt) {
            typewriter.typeString(txt).start()
        },
        open(value) {
            let selector = value.srcElement
            let text = value.srcElement.innerHTML
            let strdocid = selector.id
            // console.log(strdocid)
            // console.log(text)
            // console.log(selector.tagName)
            let row = {
                docid: strdocid
            }

            if (selector.tagName === "ITEM") {
                if (selector.id) {
                    this.add(strdocid, 1, text)
                } else {
                    return
                }
            } else if (selector.tagName === "RECOMMEND") {
                if (selector.id) {
                    this.add(strdocid, 1, text)
                } else {
                    return
                }
            }


        },
        add(fid, orderid, filename, row) {
            this.CreatePage(fid, orderid, filename, row);
        },
        connect() {
            console.log("connecting to server")
            this.rec_history_list = []
            ChatMessageQueue.clear()
            var salt = parseInt(Math.random() * (54425) + 11111, 10);
            salt = salt.toString();
            var timestamp = Math.round(new Date().getTime() / 1000)
            timestamp = timestamp.toString()
            var sign = getAISign(store.state.user.userGuid, store.state.user.token, salt, timestamp, "1")
            console.log(salt + "|" + timestamp)
            console.log(store.state.user.userGuid + "|" + store.state.user.token)
            console.log("sign===>" + sign)
            if (this.ws === null) {
                this.ws = new WebSocket(this.$baseConfig.chatsvr + '/stream/chat?sign=' + sign + '');
                this.ws.onopen = this.onOpen;
                this.ws.onmessage = this.onMessage;
                this.ws.onclose = this.onClose;
                this.ws.onerror = this.onError;
            } else {
                console.log("connect is going==>")
                console.log("send message===>")
                this.sendMessage()
            }
        },
        disconnect() {
            console.error('WebSocket close by user stop');
            if (this.ws !== null) {
                this.ws.close();
                this.ws = null;
            }
            ChatMessageQueue.clear()
            this.is_timer_processing = false
            // this.key = ''
            this.showddd = false
            clearInterval(this.typeIntervalId)
            if (cur_typewriter) {
                cur_typewriter.stop()
            }
            // this.messages=[]
            this.rec_history_list = []
            //思考图标控制
            var chat_item = this.chat_messages.find(item => item.id === this.current_chat_id)
            if (chat_item) {
                chat_item.collaspe.isThinking = false
            }
        },
        new_typewriter(element) {
            cur_typewriter = new Typewriter(element, {
                loop: false,
                delay: 75,
            });
            return cur_typewriter;
        },
        typeMessage(element) {
            console.log("start type Message")

            var tw = this.new_typewriter(element)
            console.log(tw)

            let intervalId = setInterval(() => {
                if (!ChatMessageQueue.isEmpty()) {
                    let msg = ChatMessageQueue.dequeue()
                    if (msg) {
                        this.tt2(tw, msg)
                    }
                }
            }, 300);
            this.typeIntervalId = intervalId
            this.is_timer_processing = true

        },
        sendMessage() {
            console.log('sendMessage==>')
            //如果是深度思考需要记录初次思考时间
            if (this.is_deepseek) {
                this.first_message_time = moment()
            }
            // 生成当前会话ID
            this.current_chat_id = uuid.v1()
            var str = `<chat_user><user_txt>` + this.input_txt + `</user_txt></chat_user>`
            var think_txt = `<chat_sys><reasoning_txt>Hi,我是税务AI助手 <span style="color:red;font-weight:bold;">小智</span>，很高兴遇见你。<p>我专注于税务领域，提供安全、有帮助、准确的税务相关信息。</p><p>我的设计旨在为用户提供专业的税务咨询服务。</p><p>如果您有任何关于税务的问题，欢迎随时向我咨询。</p></reasoning_txt></chat_sys>`
            var chat_item = {
                id: this.current_chat_id,
                type: this.is_deepseek ? 1 : 0,
                reasoning: [],
                user: str,
                collaspe: { key: this.current_chat_id, isShow: true, isExpanded: true, isThinking: true, label_txt: '思考中' },
                messages: [],
            }
            // chat_item.reasoning.push(think_txt)

            // this.key = uuid.v1()
            if (this.ws !== null && this.ws.readyState === WebSocket.OPEN) {
                this.chat_messages.push(chat_item)
                var args = {
                    model: Number(this.vertical),
                    question: this.input_txt,
                    request_id: this.chat_session_id,
                    is_reasoning: this.is_deepseek,
                }
                console.log(args)
                this.ws.send(JSON.stringify(args));
                this.input_txt = ''
                this.showddd = true
                //show think
            } else {
                //重连
                this.disconnect()
                this.connect()
            }

        },
        onOpen(event) {
            console.log('WebSocket connection opened:', event);
            this.sendMessage()
        },
        onMessage(event) {
            console.log('Message received from server:', event.data);
            var id_suffix = "-636f6e74656e74"
            var content_id = this.current_chat_id + id_suffix
            //查找当前会话
            var chat_item = this.chat_messages.find(item => item.id === this.current_chat_id);
            console.log(chat_item)
            var data = JSON.parse(event.data)
            this.chat_session_id = data.request_id
            var txtStream = document.getElementById(this.current_chat_id)
            var txtContentStream = document.getElementById(content_id)
            console.log("current_chat_id:" + this.current_chat_id)
            if (data.finish_reason == 'error') {
                this.$Message.warning(data.message)
                var str = `<chat_sys><sys_txt id='000999'>` + data.message + `</sys_txt></chat_sys>`
                chat_item.messages.push(str)
                this.disconnect()
                return
            }

            //处理reasoning流和content流的切换
            if (data.message == "[REASONING_DONE]") {
                const last_reasoning_message_time = moment()
                // 计算时间间隔（以毫秒为单位）
                const duration = moment.duration(last_reasoning_message_time.diff(this.first_message_time));
                // 将时间间隔转换为秒，并保留到秒（取整）
                const totalSeconds = Math.floor(duration.asSeconds())
                console.log(`时间间隔（秒）: ${totalSeconds}`)
                chat_item.collaspe.label_txt = `已深度思考，耗时（${totalSeconds}）秒`
                this.is_timer_processing = false
                clearInterval(this.typeIntervalId)
                if (cur_typewriter) {
                    cur_typewriter.stop()
                    cur_typewriter = null
                }
                var str = `<chat_sys><sys_txt id='` + content_id + `'>` + '' + `</sys_txt></chat_sys>`
                chat_item.messages.push(str)
                chat_item.collaspe.isThinking = false
                return
            }

            if (!txtStream) {
                console.log("!txtStream=>")
                if (this.is_deepseek) {
                    var str = `<chat_sys><reasoning_txt id='` + this.current_chat_id + `'>` + '' + `</reasoning_txt></chat_sys>`
                    ChatMessageQueue.enqueue(data.message)
                    chat_item.reasoning.push(str)
                } else {
                    var str = `<chat_sys><sys_txt id='` + this.current_chat_id + `'>` + '' + `</sys_txt></chat_sys>`
                    ChatMessageQueue.enqueue(data.message)
                    chat_item.messages.push(str)
                }


            } else {

                if (!this.is_timer_processing) {
                    if (txtContentStream) {
                        console.log("get txtContentStream=>")
                        console.log(txtContentStream)
                        this.typeMessage(txtContentStream)
                    } else {
                        //拉起timer开始打印
                        this.typeMessage(txtStream)
                    }

                }

                if (data.finish_reason == 'stop') {
                    console.log('switch result message===>')
                    ChatMessageQueue.clear()
                    clearInterval(this.typeIntervalId)
                    //结束推流后的渲染，推理和内容分别渲染
                    //处理全量文本中的链接a标签，增加target=“blank”
                    //var totalmsg = this.addTargetBlank(data.message)
                    if (this.is_deepseek) {
                        txtContentStream.innerHTML = ''
                        txtContentStream.innerHTML = marked.parse(this.extractTagContent(data.message, "CONTENT"))
                        txtStream.innerHTML = ''
                        txtStream.innerHTML = marked.parse(this.extractTagContent(data.message, "REASONING"))
                    } else {
                        txtStream.innerHTML = ''
                        txtStream.innerHTML = marked.parse(data.message)
                        console.log(txtStream.innerHTML)
                    }

                    // let aa = this.new_typewriter(txtStream)
                    // aa.typeString('hellow').start()
                    // cur_typewriter.typeString('hellow')
                } else if (data.finish_reason == 'policy') {
                    this.showddd = false
                    txtStream.innerHTML += ''
                    if (data.recommend) {
                        this.recommends = data.recommend
                        let recommendStr = ''
                        recommendStr += ` <div class="recommend_txt" style="color:#00B42A">相关政策</div>`
                        for (var item of data.recommend) {
                            recommendStr += `<recommend id=` + item.doc_id + ` class="suggest_item">` + item.title + `</recommend>`
                        }
                        var str = `<div class="suggest_box">` + recommendStr + `</div>`
                        chat_item.messages.push(str)
                    }

                    // clearInterval(this.typeIntervalId)
                    // this.is_timer_processing = false
                } else if (data.finish_reason == 'recommend') {
                    this.showddd = false
                    txtStream.innerHTML += ''
                    if (data.recommend) {
                        this.recommends = data.recommend
                        let recommendStr = ''
                        recommendStr += ` <div class="recommend_txt" style="color:#165DFF">官方解答</div>`
                        for (var item of data.recommend) {
                            recommendStr += `<recommend id=` + item.doc_id + ` class="suggest_item">` + item.title + `</recommend>`
                        }
                        var str = `<div class="suggest_box">` + recommendStr + `</div>`
                        chat_item.messages.push(str)
                    }

                    clearInterval(this.typeIntervalId)
                    this.is_timer_processing = false
                } else {
                    //线路4是全量推送，其他线路是增量推送
                    if (this.vertical === '4') {
                        txtStream.innerHTML = data.message
                    } else {
                        //原追消息方式
                        //txtStream.innerHTML += data.message
                        ChatMessageQueue.enqueue(data.message)
                    }
                    // this.messages.push(`<div class="loading" :style="{display:`+this.typewait+`?'block':'none'}"></div>`)
                }
                this.scrollToBottom()
            }


        },
        onClose(event) {
            console.log('WebSocket connection closed:', event);
            // this.ws = null;
            // this.key = ''
            // this.showddd = false

            ChatMessageQueue.clear()
            this.is_timer_processing = false
            this.key = ''
            this.showddd = false
            clearInterval(this.typeIntervalId)

        },
        onError(event) {
            console.error('WebSocket error observed:', event);
            ChatMessageQueue.clear()
            this.is_timer_processing = false
            this.key = ''
            this.showddd = false
            clearInterval(this.typeIntervalId)
        },
        adjustDivHeight() {
            var div = document.getElementById('chat_box');
            var left = document.getElementById('chat_box_left');
            var center = document.getElementById('chat_box_center');
            var right = document.getElementById('chat_box_right');
            var viewportWidth = window.innerWidth;
            div.style.height = window.innerHeight - 105 + 'px'; //div容器高度动态跟随浏览器高度，避免滚动条-控制整个容器的高度
            div.style.overflowX = 'hidden'
            if (viewportWidth < 960) {
                left.style.display = "none"
                right.style.display = "none"
                center.style.width = "100%"
            } else {
                left.style.display = "flex"
                right.style.display = "flex"
            }
            if (this.sliders && this.sliders.length > 0) {
                console.log(this.getSliders.length)
                console.log('add slider and change window==>')
                left.style.display = "none"
                right.style.display = "none"
                center.style.width = "100%"
            } else {
                left.style.display = "flex"
                right.style.display = "flex"
            }
        },
        isBlank(str) {
            return /^[\s]*$/.test(str);
        },
        txtchange() {
            if (this.isBlank(this.input_txt)) {
                console.log('--blank--')
                this.sendable = false
            } else {
                //console.log(this.input_txt)
                this.sendable = true
            }
        },
        // 禁用input回车换行，实现shift+enter换行
        handleKeyDown(e) {
            if (!e.shiftKey && e.keyCode === 13) {
                console.log('handleKeyDown===>')
                e.cancelBubble = true
                e.stopPropagation()
                e.preventDefault()
                if (e.keyCode === 13 && this.input_txt && this.sendable) {
                    console.log('kecode13')
                    this.submit1()
                    // this.userEnterKey()
                }
            }
        },
        // userEnterKey() {
        //     this.submit()
        // },
        submit1() {
            if (this.checkUserLogin()) {
                if (!this.showddd) {
                    this.connect()
                } else {
                    this.disconnect()
                }
            } else {
                this.$Message.warning("请先登录账户后体验AI问答功能")
                eventBus.$emit("user-login", "true", "0")
                return
            }

        },
        // submit() {
        //     // this.$Message.success("信息已发送:" + this.input_txt)
        //     var str = `<chat_user><user_txt>` + this.input_txt + `</user_txt></chat_user>`
        //     this.messages.push(str)
        //     this.chat_search(this.input_txt)
        //     this.input_txt = ''
        //     this.$nextTick(() => {
        //         this.scrollToBottom()
        //     })

        // },
        scrollToBottom() {
            console.log('scroll to go_bottomopopo====>');
            var element = document.getElementById('go_bottomopopo');
            element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        },
        new_chat_hellow() {
            var chat_item = {
                id: 0,
                type: 0,
                user: '',
                reasoning: [],
                collaspe: {},
                messages: [],
            }

            var str = `<chat_sys><sys_txt>Hi,我是税务AI助手 <span style="color:red;font-weight:bold;">小智</span>，很高兴遇见你。<p>我专注于税务领域，提供安全、有帮助、准确的税务相关信息。</p><p>我的设计旨在为用户提供专业的税务咨询服务。</p><p>如果您有任何关于税务的问题，欢迎随时向我咨询。</p></sys_txt></chat_sys>`
            chat_item.messages.push(str)
            this.chat_messages.push(chat_item)
            // this.messages.push(str)
        },
        new_chat() {
            console.log('new_chat====>');
            if (this.checkUserLogin()) {
                // this.messages = []
                this.chat_messages = []
                this.new_chat_hellow()
                ChatMessageQueue.clear()
                this.is_timer_processing = false
                this.chat_session_id = ''
                this.current_chat_id = ''
                this.rec_history_list = []
                this.rec_finished = false
                if (this.$refs.inputTxt) {
                    this.$refs.inputTxt.focus()
                }

            } else {
                this.$Message.warning("请先登录账户后体验AI问答功能")
                eventBus.$emit("user-login", "true", "0")
                return
            }
        },
        chat_list() {
            console.log('chat_list====>');
            if (this.checkUserLogin()) {
                this.value2 = true
                this.chat_history()
            } else {
                this.$Message.warning("请先登录账户后体验AI问答功能")
                eventBus.$emit("user-login", "true", "0")
                return
            }
        },
        sys_chat() {
            var str = `<chat_sys><sys_txt>` + this.input_txt + `</sys_txt></chat_sys>`
            this.messages.push(str)
            this.input_txt = ''
            this.$nextTick(() => {
                this.scrollToBottom()
            })

        },
        //没有调用
        chat_search(msg) {
            var args = {
                chattype: [1],
                question: msg
            }
            this.ai_loading()
            try {
                constJ.reqChatSearch(args).then(res => {
                    console.log(res)
                    if (res.rltcode === 1) {
                        if (res.rtncode === 1) {
                            this.messages.pop()
                            var rsp = marked.parse(res.item.MOONSHOT)
                            var str = `<chat_sys><sys_txt>` + rsp + `</sys_txt></chat_sys>`
                            this.messages.push(str)
                        }
                    }
                })
            } catch (e) {
                this.messages.pop()
            }

        },
        history_paging(page) {
            console.log(page)
            this.history_currentpage = page
            this.chat_history()
        },
        chat_history() {
            var args = {
                page: this.history_currentpage,
                pagesize: this.history_pagesize
            }
            try {
                constJ.reqChatHistory(args).then(res => {
                    console.log(res)
                    if (res.data.length > 0) {
                        this.histories = res.data
                        this.history_total = Number(res.total)
                    }
                })
            } catch (e) {}

        },
        chat_history_view(msg) {
            console.log(msg)
            //选中
            // this.messages = []
            this.chat_messages = []
            this.history_selected_id = msg.requestId
            this.rec_history_list = []
            this.rec_finished = false





            var args = {
                requestid: msg.requestId
            }
            try {
                constJ.reqChatHistoryView(args).then(res => {
                    console.log(res)
                    if (res.data.length > 0) {
                        for (let i = 0; i < res.data.length; i++) {

                            var chat_item = {
                                id: 0,
                                type: 0,
                                user: '',
                                reasoning: [],
                                collaspe: {},
                                messages: [],
                            }

                            var str = `<chat_user><user_txt>` + res.data[i].question + `</user_txt></chat_user>`
                            chat_item.user = str
                            var reasoning_str = this.extractTagContent(res.data[i].content, "REASONING")
                            var content_str = this.extractTagContent(res.data[i].content, "CONTENT")
                            reasoning_str.replace(/&lt;/g, '<').replace(/&gt;/g, '>')
                            content_str.replace(/&lt;/g, '<').replace(/&gt;/g, '>')

                            if (reasoning_str && content_str) {
                                chat_item.type = 1
                                chat_item.collaspe = { key: "0", isShow: true, isExpanded: true, label_txt: "已深度思考" }
                                //深度思考内容
                                var reason_txt = `<chat_sys><reasoning_txt>` + marked.parse(reasoning_str) + `</reasoning_txt></chat_sys>`
                                var content_txt = `<chat_sys><sys_txt>` + marked.parse(content_str) + `</sys_txt></chat_sys>`
                                chat_item.reasoning.push(reason_txt)
                                chat_item.messages.push(content_txt)

                            } else {
                                //非深度思考内容
                                chat_item.type = 0
                                var ctn = `<chat_sys><sys_txt>` + marked.parse(res.data[i].content) + `</sys_txt></chat_sys>`
                                chat_item.messages.push(ctn)
                            }
                            // this.messages.push(ctn)
                            this.value2 = false
                            this.chat_session_id = args.requestid
                            this.chat_messages.push(chat_item)
                        }
                    }
                })
            } catch (e) {}

        },
        //已引用，未生效
        ai_loading() {
            var str = `<chat_sys><loading_box><i class="icon_loading"></i><span class="loading_txt">AI思考中...</span></loading_box></chat_sys>`
            this.messages.push(str)
        },
        set_line(v) {
            console.log(v)
            switch (v) {
                case "1":
                    this.$Message.success("已切换到线路二")
                    break;
                case "2":
                    this.$Message.success("已切换到线路二")
                    break;
                case "3":
                    this.$Message.success("已切换到线路一")
                    break;
                case "4":
                    this.$Message.success("已切换到线路四")
                    break;
                default:
                    this.$Message.success("默认线路一")
            }
        },
        rec_history_edit() {
            console.log('edit rec')
        },
        rec_history_del(event, item) {
            console.log('del rec')
            // event.preventDefault(); // 阻止链接的默认行为
            event.stopPropagation(); // 阻止事件冒泡
            this.chat_history_delete(item)
        },


        clean_content() {
            // this.messages = []
            // this.chat_session_id = ''
            this.chat_messages = []
            this.chat_session_id = ''
            this.current_chat_id = ''
        },
        chat_history_delete(item) {
            console.log(item)
            var args = {
                requestid: item.requestId
            }
            try {
                constJ.reqChatHistoryDelete(args).then(res => {
                    console.log(res)
                    if (res.rtncode == 1) {
                        if (res.rltcode == 1) {
                            console.log(res.rltdesc)
                            let indexToRemove = this.rec_history_list.findIndex(p => p.requestId === item.requestId)
                            console.log(indexToRemove)
                            if (indexToRemove !== -1) {
                                this.rec_history_list.splice(indexToRemove, 1);
                                this.$Message.success("[ " + item.title + " ] 已删除")
                            }
                            return
                        } else {
                            console.log(res.rltdesc)
                            this.$Message.warning(res.rltdesc)
                            return
                        }
                    } else {
                        console.log(res.rtndesc)
                        this.$Message.warning(res.rtndesc)
                        return
                    }
                })
            } catch (e) {}
        },
        view_rec_history_all() {
            this.rec_page = 1,
                this.rec_total = 0
            this.rec_history_list = []
            this.rec_finished = false
            this.rec_history_all()
        },
        rec_history_all() {
            this.clean_content()
            console.log("rec_history_all")
            var args = {
                page: this.rec_page,
                pagesize: this.rec_pagesize
            }
            console.log(args)
            try {
                constJ.reqChatHistory(args).then(res => {
                    console.log(res)
                    if (res.data.length > 0) {
                        this.rec_history_list.push(...res.data)
                        this.rec_total = Number(res.total)
                        this.value2 = false
                    }
                })
            } catch (e) {}

        },
        handleScroll(event) {
            if (this.rec_history_list.length === 0) {
                this.rec_finished = false
                return
            }
            // 这里可以访问到滚动事件对象
            const scrollTop = event.target.scrollTop;
            const scrollHeight = event.target.scrollHeight;
            const clientHeight = event.target.clientHeight;

            // 判断是否滚动到底部
            if (scrollTop + clientHeight >= scrollHeight) {
                console.log('滚动到底部');
                // 执行滚动到底部时的逻辑
                this.loadMoreContent();
            }
        },
        loadMoreContent() {
            // 加载更多内容的逻辑

            if (this.rec_page * this.rec_pagesize < this.rec_total) {
                this.rec_page += 1
                this.rec_history_all()

            } else {
                this.rec_finished = true
                console.log("数据已加载完毕")
                return
            }
        },
        //动态提取指定标签内容的函数,const reasoningContent = extractTagContent(text, 'REASONING');
        extractTagContent(str, tagName) {
            // 构造正则表达式，匹配 [tagName] 和 [/tagName] 之间的内容
            const regex = new RegExp(`\\[${tagName}\\](.*?)\\[\\/(${tagName})\\]`, 'is');
            const match = str.match(regex);

            if (match && match[1]) {
                return match[1].trim(); // 返回匹配到的内容，并去除首尾空格
            } else {
                return ""; // 如果没有匹配到，返回空字符串
            }
        },

        checkUserLogin() {
            if (store.state.user.userId === undefined || store.state.user.userId === "" || store.state.user.accounttype === 0) {
                return false
            } else {
                return true
            }
        },

    },
    //监控多屏状态下隐藏其他字段显示，单屏还原
    watch: {
        sliders: function(v) {
            console.log('case sliders--->')
            console.log(v)
            this.adjustDivHeight()
            // this.$refs.caseTable.onSlidersChanged(MoreFun.getColumns().case)
        }
    }

}
</script>
<style lang="less">
body {
    counter-reset: section;
}

.container {
    display: flex;
    /* margin:0px;*/
    .right {
        background-color: white;
    }

    .left,
    .right {
        flex: 0 0 auto;
        /* 不放大，不缩小，保持原始尺寸 */
        width: 30%;

    }
    .left {
        display: flex;
        background-color: #fff;
        border-right: 1px solid #e8eaec;
        flex-direction: column;

        .new_btn_box {
            height: 30px;
            width: 200px;
            /*        border:1px solid blue;*/
            display: flex;
            justify-content: right;
            align-items: center;
            padding: 10px;
            /*        background-color: yellow;*/
            width: 100%;
            margin-top: 20px;
        }

        .me_info {
            height: 50px;
            width: 200px;
            display: flex;
            justify-content: right;
            align-items: center;
            padding: 10px;
            /*        background-color: yellow;*/
            width: 200px;
            margin-top: 20px;
            position: absolute;
            left: 10px;
            width: 29.5%;
            bottom: 28px;
        }

        .poptip_box {
            .ivu-poptip-inner {
                background-color: yellow;
            }
        }

        .pop_box {
            width: 200px;
            height: 200px;
            background-color: yellow;
        }

        /*调整原始组件的box间距*/
        .ivu-drawer-body {
            padding: 5px;
        }

        .li_row:hover {
            border-left: 5px solid #BEDAFF;
        }

        .li_row {
            display: flex;
            flex-direction: column;
            border-left: 5px solid white;
            padding-left: 10px;
            margin-top: 20px;
            cursor: pointer;

            .li_title {
                display: inline-block;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                width: 200px;
            }

            .li_date {
                display: flex;
                color: #808695;
            }
        }

        .pagination {
            display: flex;
            margin-top: 20px;

            .view_all {
                color: #165DFF;
                cursor: pointer;
            }
        }
    }
}



// .left {
//     display: flex;
//     background-color: #fff;
//     border-right: 1px solid #e8eaec;
//     flex-direction: column;

//     .new_btn_box {
//         height: 30px;
//         width: 200px;
//         /*        border:1px solid blue;*/
//         display: flex;
//         justify-content: right;
//         align-items: center;
//         padding: 10px;
//         /*        background-color: yellow;*/
//         width: 100%;
//         margin-top: 20px;
//     }

//     .me_info {
//         height: 50px;
//         width: 200px;
//         display: flex;
//         justify-content: right;
//         align-items: center;
//         padding: 10px;
//         /*        background-color: yellow;*/
//         width: 200px;
//         margin-top: 20px;
//         position: absolute;
//         left: 10px;
//         width: 29.5%;
//         bottom: 28px;
//     }

//     .poptip_box {
//         .ivu-poptip-inner {
//             background-color: yellow;
//         }
//     }

//     .pop_box {
//         width: 200px;
//         height: 200px;
//         background-color: yellow;
//     }

//     /*调整原始组件的box间距*/
//     .ivu-drawer-body {
//         padding: 5px;
//     }

//     .li_row:hover {
//         border-left: 5px solid #BEDAFF;
//     }

//     .li_row {
//         display: flex;
//         flex-direction: column;
//         border-left: 5px solid white;
//         padding-left: 10px;
//         margin-top: 20px;
//         cursor: pointer;

//         .li_title {
//             display: inline-block;
//             white-space: nowrap;
//             text-overflow: ellipsis;
//             overflow: hidden;
//             width: 200px;
//         }

//         .li_date {
//             display: flex;
//             color: #808695;
//         }
//     }

//     .pagination {
//         display: flex;
//         margin-top: 20px;

//         .view_all {
//             color: #165DFF;
//             cursor: pointer;
//         }
//     }
// }


.center {
    flex-grow: 1;
    /* 占据剩余空间 */
    display: flex;
    flex-direction: column;
    /* 子元素垂直排列 */
    overflow: hidden;
    /* 防止中间区域出现滚动条 */
    min-width: 580px;
}

.main-content {
    flex: 1;
    /* 占据剩余空间 */
    overflow-y: auto;
    /* 只有垂直滚动条 */
    scrollbar-width: thin;
    /* Firefox浏览器 */
    scrollbar-color: #ccc #f0f0f0;
    padding: 10px;
    flex-direction: column;

    .row {
        display: flex;
        font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        width: 100%;

        chat_user {
            display: flex;
            /* 设置为弹性容器 */
            justify-content: flex-end;
            /* 内容居右 */
            background-color: transparent;
            /* 设置背景色为透明 */
            padding: 10px;
            /* 添加一些内边距 */
            box-sizing: border-box;
            /* 确保内边距不影响外部div的宽度 */
            width: 100%;

            user_txt {
                background-color: #2d8cf0;
                /* 背景色为蓝色 */
                color: white;
                /* 文字颜色为白色，如果你想要其他颜色也可以更改 */
                padding: 10px;
                /* 根据需要给文字添加一些内边距 */
                border-radius: 15px;

            }
        }

        chat_sys {
            display: flex;
            /* 设置为弹性容器 */
            justify-content: flex-start;
            /* 内容居右 */
            background-color: transparent;
            /* 设置背景色为透明 */
            padding: 10px;
            /* 添加一些内边距 */
            box-sizing: border-box;
            /* 确保内边距不影响外部div的宽度 */

            reasoning_txt {
                color: #c5c8ce;
                font-size: 14px;
                width: 100%;
            }

            sys_txt {
                background-color: #f7f8fa;
                /* 背景色为蓝色 */
                color: #515a6e;
                /* 文字颜色为白色，如果你想要其他颜色也可以更改 */
                padding: 10px 10px 10px 10px;
                /* 根据需要给文字添加一些内边距 */
                border-radius: 15px;
                align-items: center;
                font-size: 16px;
                /*display: flex*/
                width: 100%;
                ;

                ol {
                    list-style-position: inside;
                    list-style-type: none;
                    counter-reset: section;
                    /* 每个新的ol元素都会重置计数器 */
                }

                hr {
                    margin: 20px 0px 20px 0px;
                    border: 1px dashed #6b7785;
                }

                code {
                    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
                    font-size: 0.875em;
                    background-color: transparent;
                    /* 取消背景色 */
                    color: #e5e7eb;
                    /* 浅色文字 */
                    border-radius: 0.25rem;
                }

                /* 模拟暗色主题的 pre 样式 */
                pre {
                    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
                    font-size: 0.875em;
                    line-height: 1em;
                    background-color: #86909c;
                    /* 暗色背景 */
                    color: #e5e7eb;
                    /* 浅色文字 */
                    padding: 1rem;
                    border-radius: 0.375rem;
                    overflow-x: auto;
                    /* 保留横向滚动条，以防万一 */
                    white-space: pre-wrap;
                    /* 自动换行 */
                    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
                }

                //表格美化
                /* 表格整体样式 */
                table {
                    width: 100%;
                    /* 自适应宽度 */
                    border-collapse: collapse;
                    margin: 20px 0;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                    font-family: Arial, sans-serif;
                }

                /* 表格标题样式 */
                thead {
                    background-color: #f8f9fa;
                }

                /* 表格单元格样式 */
                th,
                td {
                    padding: 12px 15px;
                    text-align: center;
                    /* 文字居中 */
                    border-bottom: 1px solid #ddd;
                }

                /* 表头单元格样式 */
                th {
                    background-color: #f1f3f5;
                    font-weight: bold;
                }

                /* 奇数行背景色 */
                tr:nth-child(odd) {
                    background-color: #f9fafb;
                }

                /* 偶数行背景色 */
                tr:nth-child(even) {
                    background-color: #ffffff;
                }

                /* 鼠标悬停时的样式 */
                tr:hover {
                    background-color: #f0f0f0;
                }

                /* 表格第一列对齐方式 */
                td:first-child,
                th:first-child {
                    text-align: center;
                    /* 第一列文字居中 */
                }

                /* 列表整体样式 */
                ul {
                    width: 100%;
                    list-style-type: disc;
                    /* 去掉默认的列表符号 */
                    list-style-position: inside;
                }

                /* 列表项样式 */
                li {
                    padding: 5px 5px;
                    // margin-left:10px;
                }

                /*li {
                    counter-increment: section;
                }
                
                li p::before {
                    content: counter(section) ". ";
                    margin-right: 5px;
                }
                li strong::before {
                    content: counter(section) ". "; 
                    margin-right: 5px; 
                }*/

                .link {
                    color: blue;
                    cursor: pointer;
                    display: inline;
                }


            }

            loading_box {
                background-color: #f8f8f9;
                /* 背景色为蓝色 */
                color: #515a6e;
                /* 文字颜色为白色，如果你想要其他颜色也可以更改 */
                /*  padding: 10px 10px 10px 10px;*/
                /* 根据需要给文字添加一些内边距 */
                border-radius: 15px;
                align-items: center;
                font-size: 15px;
                display: flex;
                flex-flow: row;
                width: 120px;

                .loading_txt {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    padding-left: 10px;
                    animation: typewriter 2s steps(7) infinite;
                    /* 7个字符，2秒内完成 */
                    /*                    width: 120px;*/
                    white-space: nowrap;
                    overflow: hidden;
                    border-right: 1px solid;
                    height: 15px;
                }
            }
        }
    }

    .dot_box {
        display: flex;
        flex-direction: row;
        margin-left: 10px;
        margin-top: 10px;
        background-color: #f7f8fa;
        height: 20px;
        width: 80px;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
    }

    /* 将动画应用于类名为'dot'的元素 */
    .dot {
        width: 10px;
        /* 圆点的宽度 */
        height: 10px;
        /* 圆点的高度 */
        border-radius: 50%;
        /* 设置为圆形 */
        background-color: black;
        /* 圆点的颜色 */
        animation: pulse 2s infinite;
        /* 应用动画，持续时间2秒，无限循环 */
        display: flex;
        margin-right: 10px;
    }
}

.row_bottom {
    display: flex;
    height: 5px;
    line-height: 6px;
    flex-direction: column;
    /*background-color: rgb(255, 248, 233);*/
    background-color: white;
    justify-items: center;
    width: 100%;
    align-items: center;

}

.main-content::-webkit-scrollbar {
    width: 8px;
    /* Chrome, Safari和Opera浏览器 */
    /*height: 8px;*/
    /* 可选，如果您想要水平滚动条的宽度 */
}

.main-content::-webkit-scrollbar-track {
    background: #f0f0f0;
    /* 滚动条轨道背景 */
}

.main-content::-webkit-scrollbar-thumb {
    background-color: #ccc;
    /* 滚动条滑块颜色 */
    border-radius: 4px;
    /* 滚动条滑块圆角 */
}

.input-area {
    flex: 0 0 auto;
    /* 不放大，不缩小，保持原始尺寸 */
    background-color: #fff;

    /* 漂亮的灰色背景 */
    .input_outer_box {
        border-radius: 15px;
        border: 2px solid #5cadff;
        margin: 10px;
        padding: 10px;
        display: flex;
        align-items: left;
        background: white;
        flex-direction: column;
        /* 纵向排列 */
        gap: 10px;

        /* 可选：控制子元素间距 */
        .input_group {
            display: flex;
            /* 子容器横向排列 */
            gap: 10px;
            /* 可选：input 和 button 之间的间距 */
        }

        .new_div {
            // background: #eee;
            padding: 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            /* 左右分离 */
            .new_kid {
                display: flex;
                padding: 5px 10px 5px 10px;
                width: 96px;
            }

            .new_kid_select {
                display: flex;
                padding: 5px 10px 5px 10px;
                background-color: #E8F7FF;
                border-radius: 15px;
                width: 96px;


            }

            .button_send {
                border-radius: 10px;
            }
        }
    }

    .txt_notice {
        display: flex;
        justify-content: center;
        width: 100%;
        /*        background-color: yellow;*/
        font-size: 12px;
        color: #808695;

    }
}


.input_box {
    height: 40px;
    width: 80%;
    margin-left: 10px;
    padding: 0 10px;
    /* 添加一些内边距，使输入框更美观 */
    border: 1px solid #e8eaec;
    /* 边框颜色与左侧边框颜色一致 */
    border-radius: 4px;
    /* 添加圆角 */
}


.titl1 {
    color: #012;
    background-color: #e5e6eb;
    align-items: center;
    display: flex;
    font-size: 14px;
    font-weight: 600;
    line-height: 50px;
    height: 80px;
    border-radius: 8px;
    padding: 10px;
    width: 100%;
}

.tag1 {
    border-radius: 5px;
    /*border: 1px solid gray;*/
    padding: 5px 10px;
    display: flex;
    width: 100%;
    justify-content: left;
    background-color: white;
    height: fit-content;

    Button {
        margin-right: 5px;
    }
}

.recommend_txt {
    display: flex;
    padding-left: 10px;
    font-weight: bold;
}

.suggest_box {
    display: flex;
    flex-direction: column;
    width: auto;
}

.suggest_item {
    display: block;
    border: 1px solid #a9aeb8;
    width: auto;
    height: auto;
    justify-content: left;
    align-items: center;
    margin: 10px 10px;
    border-radius: 10px;
    padding: 10px 10px;
    /* 添加圆角 */
    box-shadow: 0px 1px 1px 0px #f2f3f5;
    cursor: pointer;
}


/*rec_history_box*/
.rec_history_box {

    /*circulate row*/
    .row {
        display: flex;
        flex-direction: row;
        border: 2px solid transparent;
        padding: 10px;
        width: 100%;
        min-height: 40px;
        height: auto;
        border-radius: 10px;
        cursor: pointer;

        .title {
            display: inline-block; //flex无法实现省略
            flex: 2;
            align-items: center;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;

        }

        .operation {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            align-items: center;

            op_time {
                display: flex;
            }

            .oper {
                display: none;
            }
        }
    }

    .row:hover {
        border: 2px solid #7BC0FC;

        .operation {
            .op_time {
                display: none;
            }

            .oper {
                display: flex;
                width: 40px;

                .icon {
                    display: flex;
                    flex: 1;
                    justify-content: center;
                }
            }
        }

    }

    .load_complete {
        color: #86909c;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 26px;
    }
}


/*动画*/
@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.icon_loading {
    animation: rotate 2s linear infinite;
    display: inline-block;
    height: 32px;
    width: 32px;
    background-image: url("https://img1.baidu.com/it/u=3133857582,765178838&fm=253&fmt=auto&app=138&f=JPEG?w=32&h=32");
    background-position: center center;
    background-size: 32px 32px;
    background-repeat: no-repeat;
}

/*文字*/
@keyframes typewriter {
    from {
        width: 0;
    }

    to {
        width: 80%;
    }
}

/*ddd*/
@keyframes pulse {
    0% {
        transform: scale(1);
        /* 开始时为原始大小 */
        opacity: 1;
        /* 开始时完全可见 */
    }

    50% {
        transform: scale(0.5);
        /* 缩放到一半大小 */
        opacity: 0.7;
        /* 透明度降低 */
    }

    100% {
        transform: scale(1);
        /* 结束时恢复原始大小 */
        opacity: 1;
        /* 结束时恢复完全可见 */
    }
}
</style>
<!-- <style>
.ivu-collapse {
    border: none;
}

.ivu-collapse-simple {
    border-left: none;
    border-right: none;
    background-color: yellow;
    border-radius: 10px;
}

.ivu-collapse-content-box {
    /*background-color: #E8F7FF;*/
}

.ivu-collapse-content {
    color: #515a6e;
}
</style> -->